import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-12 py-5">
        <span className="text-foreground-950 text-lg font-semibold tracking-tight">
          TubiConsult AB
        </span>
      </div>
    </nav>
  );
}